/*jshint esversion: 6 */

/**
 * A class wrapper for Buefy dialog confirm.
 *
 * @author Paul Marti - pablo@intermediatica.net
 * @class LocalStorageHandler
 * @constructor
 *
 * Ported as Vue Plugin by
 * Paul Marti <pablo@intermediatica.net>
 */

let VueBuefyConfirmPlugin = {};

VueBuefyConfirmPlugin.install = (Vue, options) => {

  Vue.mixin({
    methods: {
      confirm(message, callback) {
        return this.$buefy.dialog.confirm({
          message: message,
          cancelText: 'Cancelar',
          confirmText: 'Confirmar',
          onConfirm: () => callback()
        })
      }
    }
  })
}

// Usage:
// $confirm.basic('Please confirm', result => console.log('confirmed'));

export default VueBuefyConfirmPlugin;